module.exports = __webpack_public_path__ + "imgs/treez.234cd0a17a5aea602726fc8c9340fc15.jpg";